import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&family=Space+Grotesk:wght@400;500;600;700&display=swap');

*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  :root{
    /* Modern Color Palette */
    --bg-primary: #0a0e27;
    --bg-secondary: #151b3d;
    --bg-tertiary: #1a2142;
    
    /* Gradient Colors */
    --gradient-1: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    --gradient-2: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    --gradient-3: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    --gradient-4: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
    --gradient-primary: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    --gradient-accent: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    
    /* Text Colors */
    --text-primary: #ffffff;
    --text-secondary: #b8b8d4;
    --text-muted: #6b7186;
    
    /* Accent Colors */
    --accent-primary: #667eea;
    --accent-secondary: #764ba2;
    --accent-success: #43e97b;
    --accent-warning: #feca57;
    --accent-danger: #f5576c;
    
    /* UI Elements */
    --card-bg: rgba(21, 27, 61, 0.8);
    --card-border: rgba(255, 255, 255, 0.1);
    --glass-bg: rgba(255, 255, 255, 0.05);
    --glass-border: rgba(255, 255, 255, 0.1);
    
    /* Shadows */
    --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.1);
    --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.2);
    --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.3);
    --shadow-glow: 0 0 30px rgba(102, 126, 234, 0.3);
    
    /* Spacing */
    --spacing-xs: 0.5rem;
    --spacing-sm: 1rem;
    --spacing-md: 2rem;
    --spacing-lg: 4rem;
    --spacing-xl: 6rem;
    
    /* Border Radius */
    --radius-sm: 8px;
    --radius-md: 12px;
    --radius-lg: 16px;
    --radius-xl: 24px;
    
    /* Transitions */
    --transition-fast: 0.2s ease;
    --transition-normal: 0.3s ease;
    --transition-slow: 0.5s ease;
  }
  
  html{
    font-size: 10px;
    scroll-behavior: smooth;
  }
  
  body {
    font-family: 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    background: var(--bg-primary);
    color: var(--text-primary);
    line-height: 1.8;
    overflow-x: hidden;
    font-weight: 300;
    letter-spacing: 0;
    
    /* Animated gradient background */
    background: linear-gradient(-45deg, #0a0e27, #151b3d, #1a2142, #0f1432);
    background-size: 400% 400%;
    animation: gradientShift 15s ease infinite;
    
    /* Smooth scrolling for all */
    scroll-behavior: smooth;
  }
  
  p {
    line-height: 1.9;
    margin-bottom: 1.5rem;
    font-weight: 300;
  }
  
  @keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Space Grotesk', sans-serif;
    font-weight: 600;
    line-height: 1.3;
    color: var(--text-primary);
    letter-spacing: -0.01em;
    margin-bottom: 1.5rem;
  }
  
  h1 {
    font-weight: 700;
    letter-spacing: -0.02em;
  }
  
  h2 {
    font-weight: 600;
  }
  
  h3, h4, h5, h6 {
    font-weight: 500;
  }
  
  ul, li{
    list-style: none;
  }
  
  a{
    text-decoration: none;
    color: inherit;
    transition: var(--transition-normal);
  }
  
  img, svg{
    max-width: 100%;
    height: auto;
    display: block;
  }
  
  button{
    outline: none;
    border: none;
    cursor: pointer;
    font-family: inherit;
    transition: var(--transition-normal);
  }
  
  .container {
    max-width: 1200px;
    width: 90%;
    margin: 0 auto;
  }
  
  /* Glassmorphism Card */
  .glass-card {
    background: var(--glass-bg);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-md);
  }
  
  /* Selection */
  ::selection {
    background: var(--accent-primary);
    color: white;
  }
  
  /* Scrollbar for browsers */
  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: var(--bg-secondary);
  }
  
  ::-webkit-scrollbar-thumb {
    background: var(--accent-primary);
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: var(--accent-secondary);
  }
`;
export default GlobalStyles;
